var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 60,
    viewBox: "0 0 62 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3277_20055)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5 8C21.5 5.79086 23.2908 4 25.5 4H36.5C38.7092 4 40.5 5.79086 40.5 8V13C40.5 17.4183 44.0818 21 48.5 21H53.5C55.7092 21 57.5 22.7908 57.5 25V35C57.5 37.2092 55.7092 39 53.5 39H49.5V43H53.5C57.9182 43 61.5 39.4182 61.5 35V25C61.5 20.5818 57.9182 17 53.5 17H48.5C46.2908 17 44.5 15.2091 44.5 13V8C44.5 3.58172 40.9182 0 36.5 0H25.5C21.0818 0 17.5 3.58172 17.5 8V24C17.5 28.4182 21.0818 32 25.5 32H35.5C37.7092 32 39.5 33.7908 39.5 36V52C39.5 54.2092 37.7092 56 35.5 56H25.5C23.2908 56 21.5 54.2092 21.5 52V47C21.5 42.5818 17.9183 39 13.5 39H8.5C6.29086 39 4.5 37.2092 4.5 35V25C4.5 22.7908 6.29086 21 8.5 21H12.5V17H8.5C4.08172 17 0.5 20.5818 0.5 25V35C0.5 39.4182 4.08172 43 8.5 43H13.5C15.7091 43 17.5 44.7908 17.5 47V52C17.5 56.4182 21.0818 60 25.5 60H35.5C39.9182 60 43.5 56.4182 43.5 52V36C43.5 31.5818 39.9182 28 35.5 28H25.5C23.2908 28 21.5 26.2092 21.5 24V8Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3277_20055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogo);
export default __webpack_public_path__ + "static/media/white_logo.b7c0b54e81f1fe2894d7053479eb1bde.svg";
export { ForwardRef as ReactComponent };